import { type CSSProperties } from 'react';

import { WORKSPACE_CANVAS_HORIZONTAL_PADDING, WORKSPACE_MIN_WIDTH } from '~/constants/panelWidths';

export type GetWorkspaceContentStyleParams = {
  rightPanelOpen: boolean;
  isFullscreen: boolean;
};

export function getWorkspaceContentStyle({
  rightPanelOpen,
  isFullscreen,
}: GetWorkspaceContentStyleParams): CSSProperties | undefined {
  if (!rightPanelOpen) {
    return undefined;
  }

  if (isFullscreen) {
    return { width: 0, minWidth: 0, overflow: 'hidden' };
  }

  return {
    width: `max(${WORKSPACE_MIN_WIDTH + WORKSPACE_CANVAS_HORIZONTAL_PADDING}px, calc(100vw - var(--left-nav-width, 0px) - var(--right-sidebar-width)))`,
  };
}
